module.exports = __webpack_public_path__ + "static/media/warning.63ab9e58.svg";